import { FormState } from '@vtex/admin-ui-form'
import { EmailsInput } from './EmailsInput'
import { styles } from './styles'
import { ThresholdsInput } from './ThresholdsInput'

type NotificationContentProps = {
  name: string
  form: FormState
}

export function NotificationContent(props: NotificationContentProps) {
  const { name, form } = props

  return (
    <div className={styles.notificationContent}>
      <ThresholdsInput name={`${name}.thresholds`} form={form} />
      <EmailsInput name={`${name}.emails`} form={form} />
    </div>
  )
}
